var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AnswerBlock from '../components/AnswerBlock';
import withClozeHandler from '../components/HandleClozeProvider';
import withAnswerEntered from '../components/AnswerEnteredProvider';

import styles from './taskTemplate.less';

var TaskTemplate = function (_Component) {
  _inherits(TaskTemplate, _Component);

  function TaskTemplate(props) {
    _classCallCheck(this, TaskTemplate);

    var _this = _possibleConstructorReturn(this, (TaskTemplate.__proto__ || Object.getPrototypeOf(TaskTemplate)).call(this, props));

    _this.toggleHideOverflow = function () {
      _this.resetScroll();
      _this.setState({
        hideOverflow: !_this.state.hideOverflow
      });
    };

    _this.resetScroll = function () {
      _this.$answerBlock.scrollTop = 0;
    };

    _this.state = {
      hideOverflow: false
    };
    return _this;
  }

  _createClass(TaskTemplate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          question = _props.question,
          answers = _props.answers,
          isTemplateView = _props.isTemplateView,
          className = _props.className;
      var hideOverflow = this.state.hideOverflow;

      return React.createElement(
        'div',
        { className: styles.container + ' ' + className + ' ' + (isTemplateView && styles.templateView) },
        React.createElement(
          'div',
          { className: styles.question },
          question
        ),
        React.createElement(
          'div',
          { ref: function ref(answerBlock) {
              _this2.$answerBlock = answerBlock;
            }, className: styles.answer + ' ' + (hideOverflow && styles.hideOverflow) },
          React.createElement(
            AnswerBlock,
            { toggleHideOverflow: this.toggleHideOverflow },
            answers
          )
        )
      );
    }
  }]);

  return TaskTemplate;
}(Component);

export default TaskTemplate;


TaskTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  question: PropTypes.node.isRequired,
  answers: PropTypes.node.isRequired,
  isTemplateView: PropTypes.bool
} : {};

TaskTemplate.defaultProps = {
  className: '',
  isTemplateView: false
};

var TemplateWithClozeHandler = withClozeHandler(TaskTemplate);
export var TaskTemplateWithAnswerEntered = withAnswerEntered(TemplateWithClozeHandler);